/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_P2dInputs */

const en_mk_sol_ukm_p2d = /** @type {(inputs: Mk_Sol_Ukm_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A good reply needs the right tone and the order data. Both exist, just not in the hands of whoever has a free moment.`)
};

const id_mk_sol_ukm_p2d = /** @type {(inputs: Mk_Sol_Ukm_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balasan yang baik butuh nada yang tepat dan data pesanan. Keduanya ada, tapi tidak di tangan orang yang sedang sempat membalas.`)
};

/**
* | output |
* | --- |
* | "A good reply needs the right tone and the order data. Both exist, just not in the hands of whoever has a free moment." |
*
* @param {Mk_Sol_Ukm_P2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_p2d = /** @type {((inputs?: Mk_Sol_Ukm_P2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_P2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_p2d(inputs)
	return en_mk_sol_ukm_p2d(inputs)
});